import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  deleteSiteProperty,
  clearSitePropertyAction
} from "actions/sites/sitePropertyActions";

const SitePropertyDelete = ({ formId, closeModal, selected }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearSitePropertyAction());
    };
  }, [dispatch]);

  const handleDelete = e => {
    e.preventDefault();
    dispatch(deleteSiteProperty(selected));
    closeModal();
  };

  return (
    <form
      id={formId}
      onSubmit={e => handleDelete(e)}
      className="form container"
    >
      <div>
        Are you sure you want to delete this site property? This can not be
        undone.
      </div>
    </form>
  );
};

export default SitePropertyDelete;
